export const routes = {
  eventsCalendar: "/event-calendar",

  events: "/events/Residential%20Study%20Courses/1",

  moreEvents: "/booknow/Residential%20Study%20Courses/1",
  moreProducts: "/products",
};
